<script setup lang="ts">
    const props = defineProps({
        collapsed: {
            type: Boolean,
            required: false,
        },
        to: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: true,
        },
        extraActivePath: {
            type: String,
            required: false,
        },
        exactlyActive: {
            type: Boolean,
            default: false,
        },
        // Visible but inert entry (unpaid level 4 confinement, TDD-5603).
        disabled: {
            type: Boolean,
            default: false,
        },
    });

    const { track: unpaidTrack } = useUnpaidTracking();

    const onClick = (e: Event) => {
        if (!props.disabled) return;
        e.preventDefault();
        unpaidTrack('unpaid_locked_item_clicked', { module: props.to });
    };

    const isActive = computed(() => {
        if (props.extraActivePath && useRoute().path.includes(props.extraActivePath)) {
            return true;
        }

        return props.exactlyActive ? useRoute().path === props.to : useRoute().path.includes(props.to);
    });
</script>

<template>
    <div :class="$theme('layout.sidebar_link_container')">
        <NuxtLink
            :to="to"
            class="text-current text-xs pl-11 font-inter max-md:font-medium flex items-center"
            :active-class="'bg-branding-white/10 hover:bg-branding-white/10 max-md:bg-branding-simple-grey/40'"
            :class="[$theme('layout.sidebar_link'), isActive ? $theme('layout.sidebar_link_active') : '', disabled ? 'opacity-40 cursor-not-allowed' : 'md:hover:bg-branding-rich-black']"
            :aria-disabled="disabled || undefined"
            :tabindex="disabled ? -1 : undefined"
            @click="onClick"
        >
            <span class="flex-1 min-w-0 truncate">{{ label }}</span>
            <slot name="after" />
        </NuxtLink>
    </div>
</template>
